import { Stack } from '@fluentui/react';

import ContentBox from '../../../../ContentBox';
import Create from './Create';
import DeleteForm from './DeleteForm';
import Preview from './Preview';
import PrintTemplate from './PrintTemplate';

export default () => {
  return (
    <div
      style={{
        width: "max-content",
        marginLeft: "100%",
        transform: "translateX(-100%)",
      }}
    >
      <ContentBox>
        <Stack
          horizontal
          horizontalAlign="end"
          verticalAlign="center"
          tokens={stackTokens}
        >
          <DeleteForm />
          <PrintTemplate />
          <Preview />
          <Create />
        </Stack>
      </ContentBox>
    </div>
  );
};

const stackTokens = { childrenGap: 10 };
